import React from "react";
import { Card, Collapse, Grid } from "@mui/material";
import CardBody from "../../../components/Card/CardBody";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import { useWatch } from "react-hook-form";
import QrV5 from "./V5/QrV5";
import { CustomizableTexts } from "../../../components/CustomizableTexts/CustomizableTexts";

function Qr() {
  const payAfterOrder = useWatch({ name: "extra_settings__payAfter" });
  const afterOrderRedirectUrl = useWatch({ name: "instoreAfterOrderUrl" });
  const appTarget = useWatch({ name: "appTarget" });
  const salesareaId = useWatch({ name: "id" });

  const urlAfterOrderCantWork = payAfterOrder && afterOrderRedirectUrl?.length > 0;
  return (
    <>
      <Card style={{ marginBottom: "16px" }}>
        <CardBody>
          <h3>
            <TranslationWrapper tDefault={"Qr settings"} tKey={"vestigingen.form.algemeen.headers.qr"} />
          </h3>

          <FormTextTC
            name={"instoreAfterOrderUrl"}
            tDefault={"Url after order"}
            tKey={"vestigingen.form.zuil.label.instoreAfterOrderUrl"}
            warning={{
              hasWarning: urlAfterOrderCantWork,
              text: {
                tKey: "vestigingen.form.algemeen.warning.urlAfterOrder",
                tDefault: "Redirecting after ordering won't work when pay after order is enabled.",
              },
            }}
          />
          <FormControlledInputTC
            name={"afterOrderTimeout"}
            rules={{
              min: {
                value: 0,
                message: <TranslationWrapper tKey={"The value must not be negative!"} />,
              },
            }}
            tDefault={"Url after order timeout"}
            tKey={"vestigingen.form.zuil.label.afterOrderTimeout"}
            type={"number"}
          />

          <FormSwitchTC
            name={"genQRCode"}
            tDefault={"Generate QR"}
            tKey={"vestigingen.form.algemeen.label.genQRCode"}
          />
        </CardBody>
      </Card>
      <Card style={{ marginBottom: "16px" }}>
        <CardBody>
          <h3>
            <TranslationWrapper
              tDefault={"Pay after order"}
              tKey={"vestigingen.form.algemeen.headers.pay-after-title"}
            />
          </h3>
          <FormSwitchTC
            name={"extra_settings__payAfter"}
            tDefault={"Enabled"}
            tKey={"vestigingen.form.overige.label.pay_after_enabled"}
          />
          <Collapse in={payAfterOrder} mountOnEnter unmountOnExit>
            {payAfterOrder ? (
              <FormSwitchTC
                name={"selectToPay"}
                tDefault={"Option to pay afterwards in basket"}
                tKey={"vestigingen.form.overige.label.selectToPay"}
              />
            ) : null}
            <CustomizableTexts
              translatableTexts={[
                "payafter - title",
                "payafter - body",
                "payafter - cancel button",
                "payafter - ok button",
              ]}
              vestigingId={salesareaId}
            />
          </Collapse>
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <h3>
            <TranslationWrapper tDefault={"Limieten"} tKey={"vestigingen.form.algemeen.headers.limieten"} />
          </h3>
          <FormSwitchTC
            name={"orderLimits"}
            tDefault={"Order limieten gebruiken"}
            tKey={"vestigingen.form.overige.label.orderLimits"}
          />
          <FormControlledInputTC
            name={"minOrderValue"}
            tDefault={"Min order value"}
            tKey={"vestigingen.form.overige.label.minOrderValue"}
            type={"currency"}
          />
          <FormControlledInputTC
            name={"maxOrderValue"}
            tDefault={"Max order value"}
            tKey={"vestigingen.form.overige.label.maxOrderValue"}
            type={"currency"}
          />
        </CardBody>
      </Card>
      {appTarget === "appv5.js" ? <QrV5 /> : null}
    </>
  );
}

export default Qr;
